"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var base_type_query_class_1 = require("./base-type-query.class");
var MultipleTypeQuery = /** @class */ (function (_super) {
    __extends(MultipleTypeQuery, _super);
    function MultipleTypeQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of types returned by query
    * @param limit Number of types to load
    */
    MultipleTypeQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Skips the selected number of types
     * @param skip Number of types to skip
     */
    MultipleTypeQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    MultipleTypeQuery.prototype.toObservable = function () {
        return _super.prototype.runMultipleTypesQuery.call(this);
    };
    /**
    * Gets 'Url' representation of query
    */
    MultipleTypeQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleTypesQueryUrl.call(this);
    };
    return MultipleTypeQuery;
}(base_type_query_class_1.BaseTypeQuery));
exports.MultipleTypeQuery = MultipleTypeQuery;
//# sourceMappingURL=multiple-type-query.class.js.map